<div class="cald_dialog" #pricebookLookupDialog>
  <div class="cald_header">
    <button class="close-dialog-button sap-icon" data-dismiss="modal" (click)="cancel()">&#xe03e;</button>
    <h2>{{'Admin.Pricebooks.Pricebook' | translate}}</h2>
  </div>
  <div class="cald_content">
    @if (parsingIsMandatory) {
      <div class="row">
        @if (type === 'av') {
          <span [innerHTML]="'Admin.Pricebook.AttributeValuePartNumberIsDynamicallyBuilt' | translate"></span>
        }
        @if (type === 'p') {
          <span [innerHTML]="'Admin.Pricebook.PartNumberIsDynamicallyBuilt' | translate"></span>
        }
      </div>
    }
    @if (!parsingIsMandatory) {
      <div class="table-wrapper">
        <cpq-datatable #dataTable [rowIdentifier]="'rowIdentifier'" [service]='pricebookService' [columns]="columns" [showFilter]="false" (onRowChanged)='onRowChanged($event)'
        [filter]='filter' (onRowsChanged)='onRowsChanged($event)' class="pricebook-datatable" [guid]="guid"></cpq-datatable>
      </div>
    }
  </div>

  @if (!parsingIsMandatory) {
    <div class="form-inline cald_dialog_buttonbar">
      <button type="button" id="savePricebookLookup" class="btn btn-primary fiori3-btn-primary" (click)="save()">{{'Admin.Msg.Save' | translate}}</button>
      <button id="cancelPricebookLookup" class="btn btn-tertiary fiori3-btn-tertiary" (click)="cancel()">{{'Admin.Msg.CancelButton'| translate}}</button>
    </div>
  }
  @if (parsingIsMandatory) {
    <div class="form-inline cald_dialog_buttonbar">
      <button type="button" class="btn btn-primary fiori3-btn-primary " (click)="cancel()">{{'Msg.OK' | translate}}</button>
    </div>
  }
</div>